import Vue from 'vue';
import WorkSpeedDialButton from '@/components/global_components/speed-dial/WorkSpeedDialButton';
import WorkSpeedDial from '@/components/global_components/speed-dial/WorkSpeedDial';

Vue.component('WSpeedDial', WorkSpeedDial);
Vue.component('WSpeedDialButton', WorkSpeedDialButton);
